import React from "react";
import { IRetailStoreWithDistance } from "tsi-common-react/src/models/location";
import { ISyncStoreID } from "tsi-common-react/src/models/nominals";
import { ajax } from "tsi-common-react/src/utils/ajax";

import iconIconTxt from "../../img/retail-locator/icon-txt.svg";
import { TXTSendStorePostData } from "../models";
import { buildStoreData } from "../utils";
import { LocatorSendResultsModal } from "./LocatorSendResults_Modal";

interface IProps {
    stores: ReadonlyArray<IRetailStoreWithDistance>;
    getStoreNumber: (store: IRetailStoreWithDistance) => number;
}

export const LocatorSendResultsText = (props: IProps): React.ReactNode => {
    const onSubmit = async (
        recipient: string,
        selectedStores: Set<ISyncStoreID>,
    ) => {
        const data: TXTSendStorePostData = {
            brand: "TP",
            triggerExternalCall: true,
            program: "text",
            phone: recipient,
            stores: buildStoreData(props.stores, selectedStores),
        };
        await ajax
            .post("https://api.promosis.com/api/v1/tsi-2249/text")
            .send(data);
    };

    return (
        <LocatorSendResultsModal
            modalClassName="modal-txt"
            // TODO(i18n): Use t tagged template: buttonLabel={t`Text Results`}
            buttonLabel="Text Results"
            buttonImgSrc={iconIconTxt}
            // TODO(i18n): Use t tagged template: buttonImgAlt={t`Text Results`}
            buttonImgAlt="Text Results"
            // TODO(i18n): Use t tagged template: modalTitle={t`Text Your Results`}
            modalTitle="Text Your Results"
            // TODO(i18n): Use jt to keep sentence together with interpolated components: modalDescription={jt`Check up to ${<strong>3</strong>} ${<span>results</span>} you would like texted.${<br />}Message and data rates may apply.`}
            modalDescription={
                <>
                    Check up to <strong>3</strong> <span>results</span> you
                    would like texted.
                    <br />
                    Message and data rates may apply.
                </>
            }
            inputType="phone"
            // TODO(i18n): Use t tagged template: inputPlaceholder={t`Enter a Phone Number`}
            inputPlaceholder="Enter a Phone Number"
            // TODO(i18n): Use t tagged template: submitButtonLabel={t`Send`}
            submitButtonLabel="Send"
            maxSelected={3}
            stores={props.stores}
            getStoreNumber={props.getStoreNumber}
            onSubmit={onSubmit}
        />
    );
};
